import { render } from "./FestivalsItem.vue?vue&type=template&id=ab1bf6aa&scoped=true"
import script from "./FestivalsItem.vue?vue&type=script&lang=js"
export * from "./FestivalsItem.vue?vue&type=script&lang=js"

import "./FestivalsItem.vue?vue&type=style&index=0&id=ab1bf6aa&lang=scss&scoped=true"

import exportComponent from "/var/www/html/punchline-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab1bf6aa"]])

export default __exports__